import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";

import useService from "../../../../hooks/useService";

import InformationHeader from "./components/InformationHeader";
import Metrics from "./components/Metrics";

const DashboardMetrics = () => {
  const kpiDashboardRepository = useService("repositories/kpi-metric-repository");
  const [kpiData, setKpiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  async function fetchKPIData() {
    setIsLoading(true);
    try {
      const response = await kpiDashboardRepository.query();
      setKpiData(response);
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      return error;
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchKPIData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center w-full bg-white rounded-lg h-80">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <InformationHeader />
      <Metrics data={kpiData} />
    </div>
  );
};

export default DashboardMetrics;
